import { SportsEnum } from 'types/generated/client';
import classNames from 'styles/utils/classNames';
import CoachGrid from './CoachGrid';
import { CoachType } from './props';

interface OtherCoachesSectionProps {
  coaches: CoachType[];
  listHoveredCoachId: string | null;
  setListHoveredCoachId: (id: string | null) => void;
  activeSport: SportsEnum;
  hasInstantBookSection: boolean;
  vairProMap: Record<string, boolean>;
}

const OtherCoachesSection: React.FC<OtherCoachesSectionProps> = ({
  coaches,
  listHoveredCoachId,
  setListHoveredCoachId,
  activeSport,
  hasInstantBookSection,
  vairProMap,
}) => {
  if (coaches.length === 0) {
    return null;
  }

  return (
    <div
      className={classNames(
        'h-full bg-color-bg-lightmode-secondary py-ds-3xl dark:bg-color-bg-darkmode-secondary',
        hasInstantBookSection
          ? 'mt-ds-3xl border-t border-color-border-hover-lightmode dark:border-color-border-hover-darkmode'
          : 'pt-ds-xl',
      )}
    >
      <h4 className="typography-product-subheading mb-ds-xl px-4 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary sm:px-8">
        Other coaches in your area
      </h4>

      <CoachGrid
        coaches={coaches}
        listHoveredCoachId={listHoveredCoachId}
        setListHoveredCoachId={setListHoveredCoachId}
        activeSport={activeSport}
        vairProMap={vairProMap}
      />
    </div>
  );
};

export default OtherCoachesSection;
